import {
	AVAILABLE_TRACK_API_LIST,
	AVAILABLE_MAIN_API_LIST,
} from '../../config';
// Status Types
export const SUCCESS = 'SUCCESS';
// Error Types
export const ERROR = 'ERROR';
export const NO_RESPONSE = 'NO_RESPONSE';
export const NOT_VALID = 'NOT_VALID';

type StatusTypes = typeof SUCCESS;
type ErrorTypes = typeof ERROR | typeof NO_RESPONSE | typeof NOT_VALID;
export type ResponseTypes =
	| typeof SUCCESS
	| typeof ERROR
	| typeof NO_RESPONSE
	| typeof NOT_VALID;

export function isSuccess(status: string = ERROR): boolean {
	return status === SUCCESS;
}

export function sendResponse<T extends StatusTypes, U>(
	status: T,
	data: U
): {
	status: T;
	data: U | null;
	error: null;
} {
	return {
		status,
		data,
		error: null,
	};
}

export function sendErrorResponse<T extends ErrorTypes>(
	status: T,
	errorMessage: any,
	functionCallerID: number
): {
	status: ErrorTypes;
	data: null;
	error: {
		name: string;
		message: string;
		caller: number;
	};
} {
	const { name, message } = new Error(errorMessage as any);

	return {
		status,
		data: null,
		error: {
			name,
			message,
			caller: functionCallerID,
		},
	};
}

export function isSuccessRequest(httpCode: number = 200): boolean {
	switch (httpCode) {
		case 200: // OK
		case 201: // Created
		case 202: // Accepted
		case 203: // Non-Authoritative Information
		case 204: // No Content
		case 205: // Reset Content
		case 206: // Partial Content
			return true;
		default:
			return false;
	}
}

export function getPublicApiUrl({ environment = '' }: { environment: string }) {
	return `${AVAILABLE_MAIN_API_LIST[environment]}blocks`;
}

export function postEventApiUrl(environment: string = '') {
	return `${AVAILABLE_TRACK_API_LIST[environment]}events`;
}

export function getLocation() {
	return window.location.href;
}

export function getQueryParam(
	location: string = '',
	paramKey: string = ''
): string {
	try {
		const url = new URL(location);
		const params = new URLSearchParams(url.search);

		return params.get(paramKey!)!;
	} catch (e) {
		return '';
	}
}

function waitForTimeout(timeout: number) {
	return new Promise((resolve) => {
		setTimeout(resolve, timeout);
	});
}

export function withMaxWaitLimit(cb: () => Promise<unknown>, maxWaitMs = 500) {
	return Promise.race([cb(), waitForTimeout(maxWaitMs)]);
}
